// Simple Toast Notification System
class ToastService {
  constructor() {
    this.toasts = [];
    this.container = null;
    this.init();
  }

  init() {
    // Create toast container if it doesn't exist
    if (!this.container) {
      this.container = document.createElement("div");
      this.container.id = "toast-container";
      this.container.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        pointer-events: none;
      `;
      document.body.appendChild(this.container);
    }
  }

  show(message, type = "info", duration = 5000) {
    const toast = document.createElement("div");
    const toastId = Date.now().toString();

    const colors = {
      success: "#28a745",
      error: "#dc3545",
      warning: "#ffc107",
      info: "#17a2b8",
    };

    const icons = {
      success: "✓",
      error: "✕",
      warning: "⚠",
      info: "ℹ",
    };

    toast.id = toastId;
    toast.style.cssText = `
      background: white;
      border-left: 4px solid ${colors[type] || colors.info};
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      margin-bottom: 10px;
      padding: 16px 20px;
      max-width: 400px;
      pointer-events: auto;
      transform: translateX(100%);
      transition: transform 0.3s ease-in-out;
      display: flex;
      align-items: center;
      gap: 12px;
    `;

    toast.innerHTML = `
      <div style="color: ${
        colors[type] || colors.info
      }; font-weight: bold; font-size: 18px;">
        ${icons[type] || icons.info}
      </div>
      <div style="flex: 1; color: #333; font-size: 14px; line-height: 1.4;">
        ${message}
      </div>
      <button onclick="this.parentElement.remove()" style="
        background: none;
        border: none;
        color: #999;
        cursor: pointer;
        font-size: 18px;
        padding: 0;
        margin-left: 8px;
      ">×</button>
    `;

    this.container.appendChild(toast);

    // Animate in
    setTimeout(() => {
      toast.style.transform = "translateX(0)";
    }, 10);

    // Auto remove
    setTimeout(() => {
      this.remove(toastId);
    }, duration);

    return toastId;
  }

  success(message, duration) {
    return this.show(message, "success", duration);
  }

  error(message, duration) {
    return this.show(message, "error", duration);
  }

  warning(message, duration) {
    return this.show(message, "warning", duration);
  }

  info(message, duration) {
    return this.show(message, "info", duration);
  }

  remove(toastId) {
    const toast = document.getElementById(toastId);
    if (toast) {
      toast.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (toast.parentElement) {
          toast.parentElement.removeChild(toast);
        }
      }, 300);
    }
  }

  clear() {
    if (this.container) {
      this.container.innerHTML = "";
    }
  }
}

// Create global instance
const toastService = new ToastService();

// Vue plugin
export default {
  install(app) {
    app.config.globalProperties.$toast = toastService;
    app.provide("toast", toastService);
  },
};

// Export service for direct use
export { toastService };
